import {BusinessLineType, BusinessLineTypes} from '../../common/types'

import {OrderLineItem} from './Order.types'

/**
 * Returns the display string for an order line item's quantity.
 * Shows a range (min - max) only for RMC orders when minQuantity and maxQuantity differ,
 * otherwise shows the single ordered quantity.
 */
export const getQuantityWindow = (
  lineItem: OrderLineItem,
  businessLine?: BusinessLineTypes
): string => {
  const {quantity, minQuantity, maxQuantity} = lineItem

  if (businessLine !== BusinessLineType.RMC) {
    return String(quantity)
  }

  if (maxQuantity === undefined || minQuantity === undefined) {
    return String(quantity)
  }

  if (maxQuantity - minQuantity > 0) {
    return `${minQuantity} - ${maxQuantity}`
  }

  return String(quantity)
}
